/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetCreatedMarketsAndProposalsRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetCreatedMarketsAndProposalsArgs, useGetCreatedMarketsAndProposalsSpec, useGetCreatedMarketsAndProposalsRealtime, useGetCreatedMarketsAndProposalsPagination } from '../specs/markets.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetCreatedMarketsAndProposalsRow } from '../openapi-types.gen.js';
export type { useGetCreatedMarketsAndProposalsArgs } from '../specs/markets.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetCreatedMarketsAndProposalsPaginationContract = useGetCreatedMarketsAndProposalsPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetCreatedMarketsAndProposalsInfinite` — both
 * read/write the same `PagedData<GetCreatedMarketsAndProposalsRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): creatorUserId, group, status, sortOrder, limit, cursor, pubkeys.
 */
const _useGetCreatedMarketsAndProposals = createListHook({
  spec: useGetCreatedMarketsAndProposalsSpec,
  realtime: useGetCreatedMarketsAndProposalsRealtime,
  entityKey: 'market',
  pagination: _useGetCreatedMarketsAndProposalsPaginationContract,
});
export const useGetCreatedMarketsAndProposals = _useGetCreatedMarketsAndProposals as (args: useGetCreatedMarketsAndProposalsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetCreatedMarketsAndProposals>;


/**
 * Auto-infinite: same cache as `useGetCreatedMarketsAndProposals`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetCreatedMarketsAndProposals` for "Load more"
 * buttons / non-scroll UX.
 */
const _useGetCreatedMarketsAndProposalsInfinite = createListHook({
  spec: useGetCreatedMarketsAndProposalsSpec,
  realtime: useGetCreatedMarketsAndProposalsRealtime,
  entityKey: 'market',
  pagination: _useGetCreatedMarketsAndProposalsPaginationContract,
  autoLoadMore: true,
});
export const useGetCreatedMarketsAndProposalsInfinite = _useGetCreatedMarketsAndProposalsInfinite as (args: useGetCreatedMarketsAndProposalsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetCreatedMarketsAndProposalsInfinite>;


/**
 * Per-field subscription hook for the `useGetCreatedMarketsAndProposals` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetCreatedMarketsAndProposalsField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetCreatedMarketsAndProposalsField = createFieldHook<GetCreatedMarketsAndProposalsRow>('useGetCreatedMarketsAndProposalsField');

/**
 * Hover/intent prefetch companion for `useGetCreatedMarketsAndProposals` (also covers
 * `useGetCreatedMarketsAndProposalsInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetCreatedMarketsAndProposals();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetCreatedMarketsAndProposals = createPrefetchHook(useGetCreatedMarketsAndProposalsSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetCreatedMarketsAndProposalsArgs>;
